import { Grid } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { School as SchoolIcon, DonutSmall as DonutSmallIcon, Business, Description, FindInPage, Restore, Room, Description as DescriptionIcon, } from '@material-ui/icons';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import DottedCube from 'components/Icons/DottedCube';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { deleteSubscribeJob, getJobSubscribeDetails } from '@webapps/business';
import {
  Button,
  Loader,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

const ViewBusinessSubscribe = ({ close, id, refetch }) => {
  const {
    css,
    classes,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { addToast } = useToast();

  const { data: subscribe = {}, isLoading } = useQuery(getJobSubscribeDetails, {
    key: ['jobSubscribeDetails', id],
    variables: {
      id,
    },
  });

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteSubscribe,
  } = useMutation(deleteSubscribeJob);

  useEffect(() => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      close();
    }
  }, [isSuccessDelete]);

  if (isLoading) {
    return <Loader />;
  }

  const getFrequenceLabel = (value) => {
    if (value === 'daily') {
      return 'Quotidienne';
    }
    if (value === 'weekly') {
      return 'Hebdomadaire';
    }
    return 'Mensuelle';
  };

  const deleteSubscribe = async () => {
    await mutateDeleteSubscribe({
      id,
    });
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid className={css({ fontWeight: 600, color: '#152652' })} item xs={12}>
          {subscribe?.label}
        </Grid>

        <Grid className={classes.info} item xs={12} >
          <div>
            <div className={css({ fontWeight: 600, display: 'flex', width: '100%' })}>
              <div><LocationOnIcon color="primary" className={[global.infoIcon, css({
                color: '#0060F9',
              })]} /></div>
              <div><FormattedMessage id="vitrine.adresse.city" /> :{' '}</div>
            </div>
            <div className={css({ color: '#152652' })}>
              {subscribe?.city}
            </div>
          </div>
        </Grid>

        <Grid className={classes.info} item xs={12} >
          <div>
            <div className={css({ fontWeight: 600, display: 'flex', width: '100%' })}>
              <div><DescriptionIcon color="primary" className={[global.infoIcon, css({
                color: '#0060F9',
              })]} /></div>
              <div><FormattedMessage id="subscribe.contractTypes" /> :{' '}</div>
            </div>
            {subscribe?.levels?.length && (
              <div className={css({ color: '#152652' })}>
                {subscribe?.contractTypes?.map((items, i) => (
                  <>
                    {items.label} {i === subscribe?.contractTypes.length - 1 ? '' : ', '}
                  </>
                ))}
              </div>
            )}
          </div>
        </Grid>

        <Grid className={classes.info} item xs={12} >
          <div>
            <div className={css({ fontWeight: 600, display: 'flex', width: '100%' })}>
              <div><Restore color="primary" className={[global.infoIcon, css({
                color: '#0060F9',
              })]} /></div>
              <div><FormattedMessage id="subscribe.Frequency" /> :{' '}</div>
            </div>
            {subscribe?.alertFrequency?.length && (
              <div className={css({ color: '#152652' })}>
                {getFrequenceLabel(subscribe?.alertFrequency)}
              </div>
            )}
          </div>
        </Grid>

        <Grid className={classes.info} item xs={12} >
          <div>
            <div className={css({ fontWeight: 600, display: 'flex', width: '100%' })}>
              <div><SchoolIcon color="primary" className={[global.infoIcon, css({
                color: '#0060F9',
              })]} /></div>
              <div><FormattedMessage id="subscribe.levels" /> :{' '}</div>
            </div>
            {subscribe?.levels?.length && (
              <div className={css({ color: '#152652' })}>
                {subscribe?.levels?.map(({ label }, index) => (
                  <>
                    {label} {index === subscribe?.levels?.length - 1 ? '' : ', '}
                  </>
                ))}
              </div>
            )}
          </div>
        </Grid>

        <Grid className={classes.info} item xs={12} >
          <div>
            <div className={css({ fontWeight: 600, display: 'flex', width: '100%' })}>
              <div><DonutSmallIcon color="primary" className={[global.infoIcon, css({
                color: '#0060F9',
              })]} /></div>
              <div><FormattedMessage id="subscribe.sectors" /> :{' '}</div>
            </div>
            {subscribe?.levels?.length && (
              <div className={css({ color: '#152652' })}>
                {subscribe?.sectors?.map(({ label }, index) => (
                  <>
                    {label} {index === subscribe?.sectors?.length - 1 ? '' : ', '}
                  </>
                ))}
              </div>
            )}
          </div>
        </Grid>

        <Grid className={css({ textAlign: 'lefts' })} item xs={12}>
          <Button
            className={css({ borderRadius: '400px', marginLeft: spacing(1), marginTop: spacing(3), backgroundColor: 'white' })}
            color="secondary"
            disabled={isLoadingDelete}
            onClick={deleteSubscribe}
            variant="outlined"
          >
            <FormattedMessage id="btnDelete" />
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

ViewBusinessSubscribe.propTypes = {
  id: PropTypes.string,
  refetch: PropTypes.func,
  close: PropTypes.func,
};

const styles = ({ spacing }) => ({
  info: {
    marginTop: spacing(0),
    alignItems: 'center',
    color: '#152652'
  },
  paddingTopMobile: {
    '@media screen and (max-width: 768px)': {
      paddingTop: '0 !important'
    }
  },
})

export default ViewBusinessSubscribe;
